import { services } from "../../../../constants/services";
import { getByQuery } from "../../../../utils/api";
import { IParamsResources, ResponseQ } from "../../../../common/dtos/paginate.dto";

export const GetResourceWithPaginationService = async (params: IParamsResources) => {
  const response = await getByQuery<ResponseQ<any>>(`${services.resources}/getResource`, params);
  return response;
};